module.exports = __webpack_public_path__ + "static/z-7f-17e961f91ad01bea7189121dbae54d50.jpg";